export interface IHttpClient {
    showProgress: boolean,
    method: string,
    url: string,
    storeKey: string,
    businessDate: string,
    payload?: object | null,
    token?: string | null,
    refreshToken?: string | null,
    noCache?: boolean
}

/**
 * A utility class for making HTTP requests to a remote server.
 */
export class AdoraHttpClient {

    /**
     * Sends an HTTP request to the specified URL with the given method and payload.
     * @param {string} method - The HTTP method to use for the request (e.g. GET, POST, etc.).
     * @param {string} url - The URL to send the request to.
     * @param {object | null} payload - The payload to send with the request (optional).
     * @param {string | null} token - An authorization token to send with the request (optional).
     * @returns {Promise<Response>} - A Promise that resolves to the Response object representing the server's response.
     */
    static async httpRequest(showProgress: boolean, method: string, url: string, payload: object | null, storeKey: string | null = null, businessDate: string | null = null, token: string | null = null, refreshToken: string | null = null, noCache: boolean = true): Promise<Response> {
        const performHttpRequest = async (): Promise<Response> => {
            const headers = new Headers();
            headers.append('Content-Type', 'application/json; charset=utf-8');

            if (storeKey)
                headers.append('X-Store-Key', storeKey);

            if (businessDate)
                headers.append('X-Business-Date', businessDate);

            if (noCache) {
                headers.append('pragma', 'no-cache');
                headers.append('cache-control', 'no-cache');
            }

            if (token)
                headers.append('Authorization', `Bearer ${token}`);

            if (refreshToken)
                headers.append('rtk', refreshToken);

            const init: { method: string, headers: Headers, body?: string } = {
                method: method,
                headers: headers,
            };

            payload && (init.body = JSON.stringify(payload))

            const request = new Request(url);
            const response = await fetch(request, init);
            return response;
        }

        //if (showProgress) {
        //    const response = await DialogCreators.ProgressWrapper(aOLO, performHttpRequest);
        //    return response;
        //} else {
        //    return await performHttpRequest();
        //}

        return performHttpRequest();
    }
}
